import { cachingService } from "../../helpers/cache";

const MOCK_NEWS = [
  {
    id: 1,
    title: 'Breaking Down the Creative Process',
    content: 'A step-by-step guide to understanding and improving your creative workflow.',
    created_at: '2024-03-20',
    media_url: 'https://images.unsplash.com/photo-1682687982501-1e58ab814714',
    creator_id: '1',
    creator: {
      name: 'HYK Team',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e'
    }
  },
  // ... rest of mock news
];

const initialState = {
  loading: false,
  loadingComments: false,
  comments: [],
  items: [],
  allNews: [],
  error: null,
  useMockData: false,
  savedNews: null,
  searchOverlayOpen: false,
  searchBarFloating: false,
  searchOverlayQuery: '',
  searchModeActive: false,
  searchHasRun: false,
  searchResults: [],
  searchLoading:false,
  activeTab: 'all',
  view_news: {
    "id": "",
    "created_at": "",
    "title": "",
    "content": "",
    "media_url": "",
    "updated_at": null,
    "creator_id": "",
    "total_likes": 0,
    "total_comments": 0,
    "is_saved": [],
    "is_liked": [],
    "users": {},
    "user_report": null
  },
  newsReports: [],
};

const newsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_NEWS_COMMENTS_REQUEST":
      return {
        ...state,
        loadingComments: true,
        comments: [],
      };
    case "FETCH_NEWS_COMMENTS_SUCCESS":
      return {
        ...state,
        loadingComments: false,
        comments: action.payload || []
      };
    case "FETCH_NEWS_COMMENTS_FAILURE":
      return {
        ...state,
        loadingComments: false,
        comments: [],
      };
    case 'FETCH_NEWS_REQUEST':
    case 'CREATE_NEWS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };

    case 'FETCH_NEWS_SUCCESS':
      if (action.payload) {
        return {
          ...state,
          loading: false,
          items: action.payload,
          error: null,
        };
      }
      return {
        ...state,
        loading: false,
        items: MOCK_NEWS,
        error: new Error('No news data received from API'),
      };
    case 'FETCH_ALL_NEWS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_ALL_NEWS_SUCCESS':
      return {
        ...state,
        loading: false,
        allNews: action.payload,
        error: null,
      };
    case 'FETCH_ALL_NEWS_SUCCESS_PAGINATE':
      return {
        ...state,
        loading: false,
        allNews: [...(state.allNews || []), ...action.payload],
        error: null,
      };
    case 'FETCH_ALL_NEWS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'SET_ALL_NEWS': {
      return {
        ...state,
        allNews: action.payload,
      };
    }
    case 'CREATE_NEWS_SUCCESS':
      if (action.payload?.data) {
        return {
          ...state,
          loading: false,
          items: [action.payload.data, ...state.items],
          error: null,
          useMockData: false
        };
      }
      return {
        ...state,
        loading: false,
        error: new Error('Invalid response format for news creation'),
        useMockData: false
      };

    case 'FETCH_NEWS_FAILURE':
    case 'CREATE_NEWS_FAILURE':
      console.error('API Error in reducer:', action.payload);
      // Only use mock data for fetch failures, not create failures
      if (action.type === 'FETCH_NEWS_FAILURE') {
        return {
          ...state,
          loading: false,
          items: MOCK_NEWS,
          error: action.payload,
          useMockData: true
        };
      }
      return {
        ...state,
        loading: false,
        error: action.payload,
        useMockData: false
      };

    case 'SET_LIKE_SAVE_NEWS': {
      const { news_id, isLike = false, isSave = false, actioned = 'save', user_id } = action.payload;
      let existingViewNews = state.view_news || {};
      const currentUserId = user_id;
      
      const existingAllNews = state.allNews.map(news => {
        if (news?.id === news_id) {
          let updatedIsLiked = news?.is_liked || [];
          let updatedIsSaved = news?.is_saved || [];
          
          if (actioned === 'like') {
            if (isLike) {
              // Add user to liked array if not already present
              const userExists = updatedIsLiked.some(item => 
                (typeof item === 'object' && item.user_id === currentUserId) || item === currentUserId
              );
              if (!userExists) {
                updatedIsLiked = [...updatedIsLiked, currentUserId ? { user_id: currentUserId } : currentUserId];
              }
            } else {
              // Remove user from liked array
              updatedIsLiked = updatedIsLiked.filter(item => 
                (typeof item === 'object' ? item.user_id !== currentUserId : item !== currentUserId)
              );
            }
          }
          
          if (actioned === 'save') {
            if (isSave) {
              // Add user to saved array if not already present
              const userExists = updatedIsSaved.some(item => 
                (typeof item === 'object' && item.user_id === currentUserId) || item === currentUserId
              );
              if (!userExists) {
                updatedIsSaved = [...updatedIsSaved, currentUserId ? { user_id: currentUserId } : currentUserId];
              }
            } else {
              // Remove user from saved array
              updatedIsSaved = updatedIsSaved.filter(item => 
                (typeof item === 'object' ? item.user_id !== currentUserId : item !== currentUserId)
              );
            }
          }
          
          return {
            ...news,
            is_liked: actioned === 'like' ? updatedIsLiked : news?.is_liked,
            is_saved: actioned === 'save' ? updatedIsSaved : news?.is_saved,
            total_likes: actioned === 'like' ? isLike ? (news?.total_likes || 0) + 1 : Math.max(0, (news?.total_likes || 1) - 1) : news?.total_likes,
          };
        }
        return news;
      })

      if (state.view_news && state.view_news.id === news_id) {
        let updatedIsLiked = state.view_news?.is_liked || [];
        let updatedIsSaved = state.view_news?.is_saved || [];
        
        if (actioned === 'like') {
          if (isLike) {
            const userExists = updatedIsLiked.some(item => 
              (typeof item === 'object' && item.user_id === currentUserId) || item === currentUserId
            );
            if (!userExists) {
              updatedIsLiked = [...updatedIsLiked, currentUserId ? { user_id: currentUserId } : currentUserId];
            }
          } else {
            updatedIsLiked = updatedIsLiked.filter(item => 
              (typeof item === 'object' ? item.user_id !== currentUserId : item !== currentUserId)
            );
          }
        }
        
        if (actioned === 'save') {
          if (isSave) {
            const userExists = updatedIsSaved.some(item => 
              (typeof item === 'object' && item.user_id === currentUserId) || item === currentUserId
            );
            if (!userExists) {
              updatedIsSaved = [...updatedIsSaved, currentUserId ? { user_id: currentUserId } : currentUserId];
            }
          } else {
            updatedIsSaved = updatedIsSaved.filter(item => 
              (typeof item === 'object' ? item.user_id !== currentUserId : item !== currentUserId)
            );
          }
        }
        
        existingViewNews = {
          ...state.view_news,
          is_liked: actioned === 'like' ? updatedIsLiked : state.view_news?.is_liked,
          is_saved: actioned === 'save' ? updatedIsSaved : state.view_news?.is_saved,
          total_likes: actioned === 'like' ? isLike ? (state.view_news?.total_likes || 0) + 1 : Math.max(0, (state.view_news?.total_likes || 1) - 1) : state.view_news?.total_likes,
        };
        cachingService.update(`/api/news/detail/${news_id}`, existingViewNews);
      } else {
        // invalidate the cache by id if not in view
        cachingService.invalidate([`/api/news/detail/${news_id}`]);
      }

      return {
        ...state,
        loading: false,
        view_news: existingViewNews,
        allNews: existingAllNews,
        error: null,
      };
    }

    case 'ADD_COMMENT_NEWS_SUCCESS': {
      const newComment = action.payload;
      const newCommentsList = [newComment, ...(state.comments || [])];
      let existingViewNews = state.view_news || {};
      const existingAllNews = state.allNews.map(news => {
        if (news?.id === newComment.news_id) {
          return { ...news, total_comments: (news?.total_comments || 0) + 1 };
        }
        return news;
      })
      // Update cache for the specific news item
      cachingService.update(`/api/news/${newComment.news_id}/comments`, newCommentsList);
      if (state.view_news && state.view_news.id === newComment.news_id) {
        existingViewNews = {
          ...state.view_news,
          total_comments: (state.view_news.total_comments || 0) + 1
        };
        cachingService.update(`/api/news/detail/${newComment.news_id}`, existingViewNews);
      } else {
        // invalidate the cache by id if not in view
        cachingService.invalidate([`/api/news/detail/${newComment.news_id}`]);
      }


      return {
        ...state,
        loading: false,
        comments: newCommentsList,
        view_news: existingViewNews,
        allNews: existingAllNews,
        error: null,
      };
    }
    case 'SET_VIEWUSER_SUCCESS': {
      return {
        ...state,
        items: action.payload?.news || []
      }
    }

    case 'FETCH_SAVED_NEWS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_SAVED_NEWS_SUCCESS':
      return {
        ...state,
        loading: false,
        savedNews: action.payload,
        fetchSaved: true,
        error: null
      };
    case 'FETCH_SAVED_NEWS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'SET_SAVED_NEWS': {
      return {
        ...state,
        savedNews: action.payload,
      };
    }
    case 'RESET_SAVED_NEWS_FETCH_FLAG': {
      return {
        ...state,
        fetchSaved: false,
      };
    }
    case 'FETCH_NEWS_BY_ID_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_NEWS_BY_ID_SUCCESS':
      return {
        ...state,
        loading: false,
        selectedNews: action.payload,
        error: null,
      };
    case 'FETCH_NEWS_BY_ID_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case 'OPEN_SEARCH_OVERLAY_NEWS':
      return {
        ...state,
        searchOverlayOpen: true
      };
    case 'CLOSE_SEARCH_OVERLAY_NEWS':
      return {
        ...state,
        searchOverlayOpen: false
      };
    case 'SET_SEARCH_OVERLAY_QUERY_NEWS':
      return {
        ...state,
        searchOverlayQuery: action.payload,
        searchHasRun: false,
      };
    case 'ENTER_SEARCH_MODE_NEWS':
      return {
        ...state,
        searchModeActive: true,
        searchBarFloating: true,
      };
    case 'EXIT_SEARCH_MODE_NEWS':
      return {
        ...state,
        searchModeActive: false,
        searchOverlayOpen: false,
        searchOverlayQuery: '',
        searchResults: [],
        searchHasRun: false,
        searchBarFloating: false,
      };

    case 'SEARCH_NEWS_REQUEST':
      return {
        ...state,
        searchLoading: true,
        error: null,
        searchResults: [],
        searchHasRun: true,

      };
    case 'SEARCH_NEWS_SUCCESS':
      return {
        ...state,
        searchLoading: false,
        searchResults: action.payload,
        error: null,
      };
    case 'SEARCH_NEWS_FAILURE':
      return {
        ...state,
        searchLoading: false,
        searchResults: [],
        error: action.payload,
      };

    case 'SET_ACTIVE_TAB_NEWS':
      return {
        ...state,
        activeTab: action.payload,
      };
    case 'FETCH_DETAIL_NEWS_BY_ID_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_DETAIL_NEWS_BY_ID_SUCCESS':
      return {
        ...state,
        loading: false,
        view_news: action.payload,
        error: null,
      };
    case 'FETCH_DETAIL_NEWS_BY_ID_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'SET_VIEW_NEWS': {
      return {
        ...state,
        view_news: action.payload,
      };
    }
    case 'SUBSCRIBE_SUCCESS': {
      return {
        ...state,
        ...state.view_news && {
          view_news: {
            ...state.view_news,
            users: {
              ...state.view_news?.users,
              is_subscribed: action.payload.subscribe,
              subscribers: action.payload.subscribe ?
                [...state.view_news?.users?.subscribers || [], action.payload.user]
                : (state.view_news?.users?.subscribers || []).filter(user => user && user.user_id !== action.payload.subscriber_id)
            }
          }
        },
      };
    }
    case 'UPDATE_REPORTED_NEWS': {
      return {
        ...state,
        ...state.view_news && {
          view_news: {
            ...state.view_news,
            user_report: { status: 'under review' },
          }
        },
        ...state.allNews && {
          allNews: state.allNews.map(news => {
            if (news.id === action.payload.news_id) {
              return { ...news, user_report: { status: 'under review' } };
            }
            return news;
          })
        },
        ...state.items && {
          items: state.items.map(news => {
            if (news.id === action.payload.news_id) {
              return { ...news, user_report: { status: 'under review' } };
            }
            return news;
          })
        },
        ...state.savedNews && {
          savedNews: state.savedNews.map(news => {
            if (news.id === action.payload.news_id) {
              return { ...news, user_report: { status: 'under review' } };
            }
            return news;
          })
        },
      };
    }
    case 'DELETE_NEWS': {
      return {
        ...state,
        allNews: (state.allNews || []).filter(news => news.id !== action.payload.news_id),
        items: (state.items || []).filter(news => news.id !== action.payload.news_id),
        savedNews: (state.savedNews || []).filter(news => news.id !== action.payload.news_id),
        searchResults: (state.searchResults || []).filter(news => news.id !== action.payload.news_id),
        view_news: (state.view_news || {}).id !== action.payload.news_id ? state.view_news : null,
      };
    }
    case 'FETCH_NEWS_REPORTS_REQUEST':
      return {
        ...state,
        loading: true,
        error: null,
      };
    case 'FETCH_NEWS_REPORTS_SUCCESS':
      return {
        ...state,
        loading: false,
        newsReports: action.payload,
        error: null,
      };
    case 'FETCH_NEWS_REPORTS_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case 'MANAGE_NEWS_REPORT': {
      const { news_id, action: reportAction } = action.payload;
      return {
        ...state,
        newsReports: state.newsReports.map(report =>
          report.news_id === news_id
            ? { ...report, status: reportAction === 'delete' ? 'deleted' : 'not_violating' }
            : report
        ),
      };
    }

    // Optimistic update cases
    case 'OPTIMISTIC_LIKE_UPDATE':
    case 'REVERT_LIKE_UPDATE': {
      const { updatedNews, updatedSearchResults, type } = action.payload;

      if (type === 'user') {
        return {
          ...state,
          items: updatedNews,
          searchResults: updatedSearchResults || [],
        };
      } else if (type === 'saved') {
        return {
          ...state,
          savedNews: updatedNews,
          searchResults: updatedSearchResults || [],
        };
      } else {
        return {
          ...state,
          allNews: updatedNews,
          searchResults: updatedSearchResults || [],
        };
      }
    }

    case 'OPTIMISTIC_SAVE_UPDATE':
    case 'REVERT_SAVE_UPDATE': {
      const { updatedNews, updatedSearchResults, type, news_id, saveAction, actioned } = action.payload;

      if (type === 'user') {
        return {
          ...state,
          items: updatedNews,
          searchResults: updatedSearchResults || [],
          ...(actioned === 'save' && {
            savedNews: saveAction
              ? [...(state.savedNews || []), updatedNews.find(el => el.id === news_id)]
              : (state.savedNews || []).filter(item => item.id !== news_id)
          })
        };
      } else if (type === 'saved') {
        return {
          ...state,
          savedNews: updatedNews,
          searchResults: updatedSearchResults || [],
        };
      } else {
        return {
          ...state,
          allNews: updatedNews,
          searchResults: updatedSearchResults || [],
          ...(actioned === 'save' && {
            savedNews: saveAction
              ? [...(state.savedNews || []), updatedNews.find(el => el.id === news_id)]
              : (state.savedNews || []).filter(item => item.id !== news_id)
          })
        };
      }
    }

    default:
      return state;
  }
};

export default newsReducer; 